var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.1526 2.76937C6.91203 2.1883 6.27793 1.87906 5.67118 2.04429L2.92156 2.79449C2.37789 2.94464 2 3.43807 2 4.00072C2 11.7316 8.26842 18 15.9993 18C16.5619 18 17.0554 17.6221 17.2055 17.0784L17.9557 14.3288C18.1215 13.7226 17.8117 13.0885 17.2306 12.8474L14.2309 11.5976C13.7213 11.385 13.1308 11.5318 12.7841 11.9599L11.5215 13.5005C9.32171 12.46 7.54054 10.6788 6.50009 8.47904L8.04068 7.21978C8.4688 6.86979 8.61561 6.28258 8.40294 5.77296L7.15316 2.77328V2.76993L7.1526 2.76937Z","fill":"#36373A"}));
}

Phone.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
